import { useState, useEffect } from "react";
import axios from "axios";
import { API } from "@/App";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Badge } from "@/components/ui/badge";
import { Eye, Search, Users } from "lucide-react";
import CustomerDashboard from "@/pages/CustomerDashboard";

export default function CustomerPreview() {
  const [customers, setCustomers] = useState([]);
  const [search, setSearch] = useState("");
  const [selectedCustomer, setSelectedCustomer] = useState("");
  const [selectedDispatchName, setSelectedDispatchName] = useState("");

  useEffect(() => {
    axios.get(`${API}/customers`).then(r => {
      setCustomers(r.data || []);
    }).catch(() => {});
  }, []);

  const filtered = (customers || []).filter(c => {
    const s = search.toLowerCase();
    return (c.name || '').toLowerCase().includes(s) || (c.dispatch_name || '').toLowerCase().includes(s) || (c.billing_name || '').toLowerCase().includes(s);
  });

  if (selectedCustomer) {
    return (
      <div>
        <div className="px-4 py-2 bg-blue-50 border-b flex items-center justify-between">
          <div className="flex items-center gap-2">
            <Eye className="w-4 h-4 text-blue-600" />
            <span className="text-sm font-semibold">Previewing: {selectedDispatchName || selectedCustomer}</span>
          </div>
          <Button size="sm" variant="outline" onClick={() => { setSelectedCustomer(""); setSelectedDispatchName(""); }} className="h-7 text-xs">
            Change Customer
          </Button>
        </div>
        <CustomerDashboard previewCustomerName={selectedCustomer} previewDispatchName={selectedDispatchName} />
      </div>
    );
  }

  return (
    <div className="p-6" data-testid="customer-preview-page">
      <div className="mb-6">
        <h1 className="text-2xl font-bold mb-1" style={{ fontFamily: 'Manrope' }}>Customer Preview</h1>
        <p className="text-sm text-muted-foreground">Select a customer to view their portal dashboard</p>
      </div>

      <div className="max-w-lg">
        <div className="relative mb-4">
          <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-muted-foreground" />
          <Input value={search} onChange={e => setSearch(e.target.value)} placeholder="Search customer..."
            className="pl-9 h-10" data-testid="customer-preview-search" />
        </div>
        <div className="border rounded-lg overflow-y-auto" style={{ maxHeight: '500px' }}>
          {filtered.length > 0 ? filtered.map(c => (
            <button key={c.id || c.name}
              onClick={() => { setSelectedCustomer(c.name); setSelectedDispatchName(c.dispatch_name || c.name); }}
              className="w-full text-left px-4 py-3 border-b last:border-0 hover:bg-blue-50/50 transition-colors flex items-center gap-3"
              data-testid={`preview-customer-${c.name}`}>
              <Users className="w-4 h-4 text-muted-foreground flex-shrink-0" />
              <span className="text-sm font-medium">{c.dispatch_name || c.name}</span>
              {c.dispatch_name && c.dispatch_name !== c.name && (
                <span className="text-[10px] text-muted-foreground">({c.name})</span>
              )}
            </button>
          )) : (
            <p className="text-sm text-muted-foreground text-center py-8">No customers found</p>
          )}
        </div>
        <p className="text-xs text-muted-foreground mt-2">{filtered.length} customers</p>
      </div>
    </div>
  );
}
